<template>
  <div class="declareBox">
    <div class="title"></div>
    <div class="content">
      <a-table
        bordered
        :loading="outsideAllListLoading"
        :data-source="outsideAllListData"
        :rowKey="(outsideAllListData) => outsideAllListData.id"
        :scroll="{ x: 1500 }"
      >
        <a-table-column :ellipsis="true" title="赛事名称" dataIndex="matchName">
        </a-table-column>
        <a-table-column :ellipsis="true" title="年份" dataIndex="year">
        </a-table-column>
        <a-table-column :ellipsis="true" title="届数" dataIndex="session">
        </a-table-column>
        <a-table-column :ellipsis="true" title="赛道" dataIndex="track">
        </a-table-column>
        <a-table-column
          :ellipsis="true"
          title="参赛组别"
          dataIndex="competitionGroup"
        >
        </a-table-column>
        <a-table-column
          :ellipsis="true"
          title="参赛类别"
          dataIndex="competitionType"
        >
        </a-table-column>
        <a-table-column
          :ellipsis="true"
          title="项目企划书"
          dataIndex="proposal"
        >
          <template slot-scope="proposal">
            <div
              style="width: 30px; margin: 0 auto"
              @click="btnOpenFile(proposal)"
            >
              <a-icon style="font-size: 16px" type="diff" theme="filled" />
            </div>
          </template>
        </a-table-column>
        <a-table-column
          :ellipsis="true"
          title="参赛阶段"
          dataIndex="attendType"
        >
        </a-table-column>
        <a-table-column
          :ellipsis="true"
          title="国赛获奖情况"
          dataIndex="nationAwardConditition"
        >
          <template slot-scope="nationAwardConditition">
            {{ nationAwardConditition == '' ? '无' : nationAwardConditition }}
          </template>
        </a-table-column>
        <a-table-column
          :ellipsis="true"
          title="省赛获奖情况"
          dataIndex="provinceAwardCondition"
        >
          <template slot-scope="provinceAwardCondition">
            {{ provinceAwardCondition == '' ? '无' : provinceAwardCondition }}
          </template>
        </a-table-column>
        <a-table-column
          :width="150"
          fixed="right"
          title="操作"
          dataIndex="operation"
        >
          <template slot-scope="id, outsideAllListData">
            <span>
              <!-- <a @click="() => btnEdit(outsideAllListData.matchId)">编辑</a> -->
              <a-popconfirm
                title="确定删除?"
                ok-text="确定"
                cancel-text="取消"
                @confirm="btnDelect(outsideAllListData.id)"
              >
                <a>删除</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      :title="modalName"
      v-model="visibleAdd"
      :confirm-loading="confirmLoading"
      @ok="AddhandleOk"
    >
      <a-form
        :form="modelForm"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
        @submit="handleSubmit"
      >
        <a-form-item label="参赛阶段">
          <a-select
            placeholder="请选择参赛阶段"
            v-decorator="[
              'attendType',
              {
                rules: [{ required: true, message: '请选择参赛阶段' }],
              },
            ]"
          >
            <a-select-option
              v-for="(item, index) in matchTypeData"
              :key="index"
              :value="item.id"
            >
              {{ item.typeName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="选择国际获奖情况">
          <a-select
            placeholder="请选择国际获奖情况"
            v-decorator="[
              'nationAwardConditition',
              {
                rules: [{ required: true, message: '请选择国际获奖情况' }],
              },
            ]"
          >
            <a-select-option
              v-for="(item, index) in getAwardData"
              :key="index"
              :value="item.name"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="选择省赛获奖情况">
          <a-select
            placeholder="请选择省赛获奖情况"
            v-decorator="[
              'provinceAwardCondition',
              {
                rules: [{ required: true, message: '请选择省赛获奖情况' }],
              },
            ]"
          >
            <a-select-option
              v-for="(item, index) in getAwardData"
              :key="index"
              :value="item.name"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import ClipboardJS from 'clipboard'
export default {
  data() {
    return {
      userId: this.$route.params.id,
      outsideAllListLoading: true,
      outsideAllListData: [],
      pageSize: 10,
      current: 1,
      total: 0,
      confirmLoading: false,
      modelForm: this.$form.createForm(this, {
        name: 'modelForm',
      }),
      modalName: '编辑课程',
      visibleAdd: false,
      getAwardData: [
        {
          name: '金奖',
        },
        {
          name: '银奖',
        },
        {
          name: '铜奖',
        },
        {
          name: '无',
        },
      ],
      matchTypeData: [],
      editId: '',
    }
  },
  methods: {
    btnOpenFile(url) {
      console.log(url)
      window.open(url)
    },
    getTypes(id) {
      let data = {
        matchType: id == 1 ? 0 : 1,
      }
      this.$http(this.$api.GETALLMATCHTYPES, data).then((r) => {
        console.log(r)
        this.matchTypeData = r.data
      })
    },
    getPageData() {
      let data = {
        id: this.userId,
      }
      this.$http(this.$api.GETAWARDDATA, data).then((r) => {
        console.log(r)
        this.outsideAllListLoading = false
        this.outsideAllListData = r.data
        this.total = r.data.total
      })
    },
    //删除这条记录
    btnDelect(id) {
      let data = {
        id,
      }
      this.outsideAllListLoading = true
      this.$http(this.$api.DELETEAWARD, data).then((r) => {
        console.log(r)
        this.$notification['success']({
          message: '删除成功',
          description: '课程删除成功',
        })
        this.getPageData()
      })
    },
    //编辑这条记录
    btnEdit(id) {
      console.log(id)
      this.getTypes(id)
      this.editId = id
      this.visibleAdd = true
      let flagData = this.outsideAllListData.find((Element) => {
        return Element.matchId == id
      })
      console.log(flagData)
      this.$nextTick(() => {
        this.modelForm.setFieldsValue({
          nationAwardConditition: flagData.nationAwardConditition,
          provinceAwardCondition: flagData.provinceAwardCondition,
          attendType: flagData.attendType,
        })
      })
    },
    AddhandleOk() {
      this.handleSubmit()
    },
    handleSubmit() {
      this.confirmLoading = true
      this.modelForm.validateFields((err, data) => {
        if (!err) {
          data.id = this.editId
          console.log('Received values of form: ', data)
          this.$http(this.$api.CHANGEGETAWARD, data).then((r) => {
            console.log(r)
            this.confirmLoading = false
            this.visibleAdd = false
            this.getPageData()
            this.$notification['success']({
              message: '修改获奖情况',
              description: '获奖情况编辑成功',
            })
          })
        }
      })
    },
    //复制链接
    btnCopyLink() {
      var clipboard = new ClipboardJS('.btnCopyLink')
      let that = this
      clipboard.on('success', function () {
        that.$message.success('地址复制成功')
      })
      clipboard.on('error', function (e) {
        console.log(e)
      })
    },
  },
  created() {
    this.getPageData()
  },
}
</script>
<style scoped lang="less">
.declareBox {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .title {
    text-align: center;
    height: 40px;
    font-size: 15px;
    line-height: 40px;
    width: 100%;
    font-weight: bold;
  }

  /deep/ .ant-table-tbody {
    .border {
      position: relative;
      top: -0.06em;
      display: inline-block;
      width: 1px;
      height: 0.9em;
      margin: 0 8px;
      vertical-align: middle;
      background-color: #e8e8e8;
    }
  }
}
</style>
